import { Injectable } from '@angular/core';
import {Registration} from '../../classes/Registration';
import {Payer} from '../../classes/Payer';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  registration: Registration;
  goBack: boolean;

  constructor() { }

  getPayer(): Payer {
    const payer: Payer = {
      name: this.registration.name,
      surname: this.registration.surname,
      email: this.registration.email,
      mobile: this.registration.mobile,
      city: '',
      street: '',
      postalCode: '',
      countryCode: 'CZE',
      symbol: 'sym',
    };
    return payer;

  }
}
